import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Form, Input } from 'antd';
import withForm from 'src/components/withForm';
import ActionModal from 'src/components/ActionModal';
import ResetFormItem from 'src/components/ResetFormItem';
import ActionModalFooter from 'src/components/ActionModal/components/ActionModalFooter';
import i18n from 'src/i18n';
import styles from './styles.module.scss';

@observer
class ParcelNoteModal extends React.Component {
  constructor(props) {
    super(props);
    this.vm = props.vm;
    this.vm.init({ form: props.form });
  }

  render() {
    return (
      <ActionModal vm={this.vm.modalVM} width={375} onCancel={this.vm.close}>
        <div className={styles.container}>
          <Form form={this.vm.form} disabled={this.vm.disabled.form}>
            <div className={styles.item}>
              <div className={styles.label}>
                {i18n.t('parcel_note_modal_note_label')}
              </div>

              <ResetFormItem name="report" errorMessageAbsolute>
                <Input.TextArea
                  autoSize={{ minRows: 6, maxRows: 12 }}
                  placeholder={i18n.t('parcel_note_modal_note_placeholder')}
                />
              </ResetFormItem>
            </div>
          </Form>

          <ActionModalFooter
            cancelProps={{
              onClick: this.vm.close,
              disabled: this.vm.disabled.footer,
              children: i18n.t('parcel_note_modal_cancel_button_label')
            }}
            confirmProps={{
              onClick: this.vm.onConfirm,
              disabled: this.vm.disabled.footer,
              children: i18n.t('parcel_note_modal_confirm_button_label')
            }}
          />
        </div>
      </ActionModal>
    );
  }
}

ParcelNoteModal.propTypes = {
  vm: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};

ParcelNoteModal.defaultProps = {};

export default withForm(ParcelNoteModal);
